/* eslint-disable camelcase */

import {defaultTheme} from '@stencil/build-theme';
import HappyFoodIcon from '@stencil/icons/src/HappyFoodIcon/HappyFoodIcon';
import HappyFoodDeliveryIcon from '@stencil/icons/src/HappyFoodDeliveryIcon/HappyFoodDeliveryIcon';
import HappyFoodDeliveryNotIcon from '@stencil/icons/src/HappyFoodDeliveryNotIcon/HappyFoodDeliveryNotIcon';
import HappySmokingIcon from '@stencil/icons/src/HappySmokingIcon/HappySmokingIcon';
import HappyAlcoholIcon from '@stencil/icons/src/HappyAlcoholIcon/HappyAlcoholIcon';
import HappyAlcoholNotIcon from '@stencil/icons/src/HappyAlcoholNotIcon/HappyAlcoholNotIcon';
import HappyNonVegIcon from '@stencil/icons/src/HappyNonVegIcon/HappyNonVegIcon';
import HappyNonVegFoodNotAllowed from '@stencil/icons/src/HappyNonVegFoodNotAllowed/HappyNonVegFoodNotAllowed';
import HappyVegIcon from '@stencil/icons/src/HappyVegIcon/HappyVegIcon';
import HappyOfferIcon from '@stencil/icons/src/HappyOfferIcon/HappyOfferIcon';
import HappyOutsideFoodIcon from '@stencil/icons/src/HappyOutsideFoodIcon/HappyOutsideFoodIcon';
import HappyOutsideFoodNotIcon from '@stencil/icons/src/HappyOutsideFoodNotIcon/HappyOutsideFoodNotIcon';
import HappySmokingNotIcon from '@stencil/icons/src/HappySmokingNotIcon/HappySmokingNotIcon';
import HappyAverageMealCostIcon from '@stencil/icons/src/HappyAverageMealCostIcon/HappyAverageMealCostIcon';
import HappyCuisineIcon from '@stencil/icons/src/HappyCuisineIcon/HappyCuisineIcon';
import HappyEggterianIcon from '@stencil/icons/src/HappyEggterianIcon/HappyEggterianIcon';
import Happy24HourMealIcon from '@stencil/icons/src/Happy24HourMealIcon/Happy24HourMealIcon';
import HappyMealTimeIcon from '@stencil/icons/src/HappyMealTimeIcon/HappyMealTimeIcon';
import HappyTickMarkIcon from '@stencil/icons/src/HappyTickMarkIcon/HappyTickMarkIcon';
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';

interface IconProps {
  width: string;
  height: string;
  fill: string;
  margin: string;
}

const nameToIconMapUtil = (isMweb: boolean) => {
  const iconProps = {
    width: isMweb ? '2rem' : '3.6rem',
    height: isMweb ? '2rem' : '3.6rem',
    margin: isMweb ? '5px 5px auto auto' : 'unset',
  };
  return {
    // Allowed
    ic_fd_outside_avl: <HappyOutsideFoodIcon {...iconProps} />,
    ic_foodtype_icon: <HappyFoodIcon {...iconProps} />,
    ic_fd_delivery_avl: <HappyFoodDeliveryIcon {...iconProps} />,
    ic_smoking_allowed: <HappySmokingIcon {...iconProps} />,
    ic_alcohol_allowed: <HappyAlcoholIcon {...iconProps} />,
    ic_nonveg_allowed: <HappyNonVegIcon {...iconProps} />,

    // Not Allowed
    ic_fd_outside_navl: <HappyOutsideFoodNotIcon {...iconProps} />,
    ic_fd_delivery_navl: <HappyFoodDeliveryNotIcon {...iconProps} />,
    ic_smoking_not_allowed: <HappySmokingNotIcon {...iconProps} />,
    ic_alcohol_not_allowed: <HappyAlcoholNotIcon {...iconProps} />,
    ic_nonveg_not_allowed: <HappyNonVegFoodNotAllowed {...iconProps} />,

    ic_veg: <HappyVegIcon {...iconProps} />,
    ic_nonveg: <HappyNonVegIcon {...iconProps} />,
    ic_veg_nonveg: <HappyNonVegIcon {...iconProps} />,
    ic_meal_time: <HappyMealTimeIcon {...iconProps} />,
    ic_avg_meal_cost: <HappyAverageMealCostIcon {...iconProps} />,
    ic_cuisines: <HappyCuisineIcon {...iconProps} />,
    ic_egg: <HappyEggterianIcon {...iconProps} />,
    ic_24hr_time: <Happy24HourMealIcon {...iconProps} />,
    ic_offers: (
      <HappyOfferIcon
        width="2rem"
        height="2rem"
        margin="5px 5px auto auto"
        fill={defaultTheme.colors.goGreen.base}
      />
    ),
  };
};

const defaultIcon = <HappyFoodIcon />;

// eslint-disable-next-line import/prefer-default-export
export const getIconFromName = (iconName: string, isMweb?: boolean) => {
  return nameToIconMapUtil(isMweb)[iconName] || defaultIcon;
};

export function getInclusionIcon(iconType: string, iconProps: IconProps) {
  switch (iconType) {
    case 'CROSS': {
      iconProps.fill = 'red';
      return <HappyCloseIcon {...iconProps} />;
    }
    case 'DEFAULT': {
      return <HappyTickMarkIcon {...iconProps} />;
    }
    default: {
      return <HappyTickMarkIcon {...iconProps} />;
    }
  }
}
